import React from "react";
import Rollbar from '../utils/RollbarTracking'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import Form from 'react-bootstrap/Form'
import axios from 'axios'
import { toast } from 'react-toastify';

export class CustomersImport extends React.Component {

  constructor(props)  {
      super(props);
      this.handleChange = this.handleChange.bind(this);
  }

  state = {
      customers: [],
      totalImport: 0
  }

  handleChange (evt) {
    var total = this.state.totalImport
    if (evt.target.checked) {
      total++
    } else {
      total--
    }
    var customers = this.state.customers
    var index = customers.findIndex(e => e.UID === evt.target.id);
    customers[index].import = evt.target.checked
    this.setState({ customers: customers, totalImport: total });
  }

  componentWillMount() {
    this.fetchCustomers();
  }

  fetchCustomers = async () => {
    toast.warning('Syncing Customers...please wait', {autoClose: false})
    axios.get('/myob/customers')
        .then(data => {
          toast.dismiss()
          console.log(data);
          this.setState({
            customers: data
          });
        })
        .catch (err => {
          toast.dismiss()
          console.log(err);
          Rollbar.error(err)
          toast.error('Failed to fetch customers from MYOB')
        })
  }

  importCustomers = async () => {
    toast.warning('Importing customers..please wait', {autoClose: false})
    axios.post('/myob/import/customers', {customers: this.state.customers})
        .then(data => {
          toast.dismiss()
          console.log(data);
          toast.success('Invite emails sent')
          this.props.history.push('/customers')
        })
        .catch (err => {
          toast.dismiss()
          console.log(err)
          Rollbar.error(err)
          toast.error('Failed to import customer')
        })
  }

  selectCustomer(cell, row, enumObject, rowIndex) {
    return (
      <Form.Check 
        custom
        type={'checkbox'}
        label="#"
        id={row.UID}
        checked={row.import}
        onChange={(e) => {this.handleChange(e)}}
      />
    )
  }

    render() {
        return (
          <div>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-1 mb-3 border-bottom">
              <h1 className="h3">Import Customers</h1>
            </div>
            <button type="button" className="btn btn-success btn-sm mar-bot" disabled={!this.state.totalImport} onClick={this.importCustomers}>Import ({this.state.totalImport}) Customers</button>
            <BootstrapTable data={this.state.customers} striped={true} hover={true} options={{sizePerPage: 50}} pagination>
              <TableHeaderColumn dataField="UID" isKey={true}>UID</TableHeaderColumn>
              <TableHeaderColumn dataField="FirstName" dataSort={true} filter={{ type: 'TextFilter' }}>First Name</TableHeaderColumn>
              <TableHeaderColumn dataField="LastName" dataSort={true} filter={{ type: 'TextFilter' }}>Last Name</TableHeaderColumn>
              <TableHeaderColumn dataField="CompanyName" dataSort={true} filter={{ type: 'TextFilter' }}>Company Name</TableHeaderColumn>
              <TableHeaderColumn dataFormat={(c, r)=>{return r.Addresses ? r.Addresses[0].Email : ''}} dataSort={true} filter={{ type: 'TextFilter' }}>Email</TableHeaderColumn>
              <TableHeaderColumn dataSort={true} dataFormat={this.selectCustomer.bind(this)}>Import</TableHeaderColumn>
            </BootstrapTable>
          </div>
        );
    }
}
